import { render, staticRenderFns } from "./Yo-upload.vue?vue&type=template&id=1a29dfe3&scoped=true&"
import script from "./Yo-upload.vue?vue&type=script&lang=js&"
export * from "./Yo-upload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a29dfe3",
  null
  
)

export default component.exports